/**
 * Generates commons names for async actions and then calls alt.generateActions() with the array of action names.
 * @param  {Object} alt
 * @param  {Array} asyncActions Array of async action names
 */
'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ('value' in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

exports.generateAsyncActions = generateAsyncActions;
exports['default'] = generateWithAsyncActions;
exports.seamlessImmutable = seamlessImmutable;
exports.pureRender = pureRender;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) arr2[i] = arr[i]; return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError('Cannot call a class as a function'); } }

/**
 * Can be used by alt source to return a promise when a axios promise is already fetching data.
 * Simplifies the use of loading since the alt loading and shouldFetch are unreliable and don't return a promise.
 */

var _axios = require('axios');

var _axios2 = _interopRequireDefault(_axios);

var _seamlessImmutable = require('seamless-immutable');

var _seamlessImmutable2 = _interopRequireDefault(_seamlessImmutable);

/**
 * React 15.0.1 does not include context in their shallowCompare function.  pure-render-decorator does not pass
 *     context to the shallowCompare function.  This is a copy of those two functions passing context.
 */

var _fbjsLibShallowEqual = require('fbjs/lib/shallowEqual');

var _fbjsLibShallowEqual2 = _interopRequireDefault(_fbjsLibShallowEqual);

function generateAsyncActions(alt) {
    if (!alt) {
        return null;
    }

    for (var _len = arguments.length, asyncActions = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        asyncActions[_key - 1] = arguments[_key];
    }

    var actionsList = asyncActions.reduce(function (list, action) {
        list.push(action + 'Starting', action + 'Success', action + 'Failure');
        return list;
    }, []);

    return alt.generateActions.apply(alt, _toConsumableArray(actionsList));
}

;

/**
 * Generates commons names for async actions and concats non async actions
 * and then calls alt.generateActions() with the array of action names.
 * @param  {Object} alt
 * @param  {Array} asyncActions Array of async action names
 * @param  {Array} actions      Array of non async action names
 */

function generateWithAsyncActions(alt, asyncActions, actions) {
    if (!alt) {
        return null;
    }

    if (!actions) {
        actions = [];
    }

    if (!asyncActions) {
        asyncActions = [];
    }

    if (!!asyncActions) {
        var asyncActionsArray = [];
        for (var i = 0; i < asyncActions.length; i++) {
            var action = asyncActions[i];
            asyncActionsArray.push(action, action + 'Starting', action + 'Success', action + 'Failure');
        }
    }

    return alt.generateActions.apply(alt, asyncActionsArray.concat(actions));
}

;
var AxiosSourceLoadingPromise = (function () {
    function AxiosSourceLoadingPromise(url, params) {
        _classCallCheck(this, AxiosSourceLoadingPromise);

        if (!url) {
            throw 'AxiosSourceLoadingPromise requires a URL to be able to determine loading status is complete';
        }
        this.loading = false;
        this.promise = null;
        this.resolve = null;
        this.reject = null;
        this.url = url;
        this.params = params;
    }

    _createClass(AxiosSourceLoadingPromise, [{
        key: 'reset',
        value: function reset() {
            this.promise = null;
            this.resolve = null;
            this.reject = null;
        }
    }, {
        key: 'handleLoading',
        value: function handleLoading() {
            var _this = this;

            var me = this;

            if (this.loading) {

                this.promise = new Promise(function (resolve, reject) {
                    _this.resolve = resolve;
                    _this.reject = reject;
                });

                return this.promise;
            } else {
                this.loading = true;

                var interceptor = _axios2['default'].interceptors.response.use(function (response) {
                    if (response.config.url === me.url && me.params === response.config.params) {
                        me.loading = false;

                        if (me.promise) {
                            me.resolve(response);
                            me.reset();
                            _axios2['default'].interceptors.request.eject(interceptor);
                        }
                    }
                    return response;
                }, function (error) {
                    if (error.config.url === me.url && me.params === response.config.params) {
                        me.loading = false;

                        if (me.promise) {
                            me.reject(error);
                            me.reset();
                            _axios2['default'].interceptors.request.eject(interceptor);
                        }
                    }
                    return Promise.reject(error);
                });
            }
        }
    }]);

    return AxiosSourceLoadingPromise;
})();

exports.AxiosSourceLoadingPromise = AxiosSourceLoadingPromise;

function seamlessImmutable(StoreModel) {
    StoreModel.config = {
        setState: function setState(currentState, nextState) {
            this.state = nextState;
            return this.state;
        },

        getState: function getState(currentState) {
            return currentState;
        },

        onSerialize: function onSerialize(state) {
            return state.asMutable();
        },

        onDeserialize: function onDeserialize(data) {
            return (0, _seamlessImmutable2['default'])(data);
        }
    };

    return StoreModel;
}

;
function pureRender(component) {
    //avoiding arrow function so that "this" is the component's scope
    var shouldComponentUpdate = function shouldComponentUpdate(nextProps, nextState, nextContext) {
        return !(0, _fbjsLibShallowEqual2['default'])(this.props, nextProps) || !(0, _fbjsLibShallowEqual2['default'])(this.state, nextState) || typeof nextContext !== 'undefined' && !(0, _fbjsLibShallowEqual2['default'])(this.context, nextContext);
    };

    component.prototype.shouldComponentUpdate = shouldComponentUpdate;
}

;


/*****************
 ** WEBPACK FOOTER
 ** ./~/epic-alt-utils/lib/index.js
 ** module id = 6
 ** module chunks = 0
 **/